import { Doughnut } from "vue-chartjs";
import 'chartjs-plugin-labels';
export default {
    extends: Doughnut,

    props: ["mData", "mLabels", "options"],

    data(){
        return {

        }
    },


    mounted() {
        let vm = this;
        let options = {
            responsive: true,
            maintainAspectRatio: false,
            cutoutPercentage: 60,
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        let value = data['datasets'][0]['data'][tooltipItem['index']];
                        let mLabel = data['labels'][tooltipItem['index']];

                        return mLabel+': '+vm.formatPrice(value)+' ECV';
                    }
                }

            },
            plugins: {
                labels: {
                    render: 'percentage',
                    fontColor: 'white',
                    precision: 2,
                }
            },
        };

        let dataset = {
            labels: JSON.parse(this.mLabels),
            datasets: [
                {
                    // label: "Data One",
                    backgroundColor: ["#71c78d", "#E46651", "#00D8FF", "#a172ff", "#d0c9cc",],
                    data: JSON.parse(this.mData),
                }
            ]
        };

        this.renderChart(dataset, options)

    }
};


